import React from 'react';

// Prioritizes word break, else  if a word is long enough that it overflow it breaks it mid-word
// & wraps it in the next line with a hyphen
export const smartWordBreakStyle: React.CSSProperties = {
  wordBreak: 'break-word',
  hyphens: 'auto',
  overflowWrap: 'break-word',
};
